export default "__VITE_ASSET__9349fd8b__"